export default "__VITE_ASSET__d5e87a04__"